import { getPercentageAllocationInventoryToTarget } from './getPercentageAllocationInventoryToTarget'

import { formatPercentageSubAllocationLineItems } from './formatPercentageSubAllocationLineItems'
import { formatPercentageSingleAllocationLineItem } from './formatPercentageSingleAllocationLineItem'

import { IS_SUB_ALLOCATION } from '../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/fields'

export const formatPercentageAllocationLineItems = ({ values, right, campaignId, currency }) => {
  const inventory = getPercentageAllocationInventoryToTarget(values, right)
  const isSubAllocation = right[IS_SUB_ALLOCATION]

  if (isSubAllocation) {
    return formatPercentageSubAllocationLineItems({
      inventory,
      values,
      right,
      campaignId,
      currency
    })
  } else {
    const lineItem = formatPercentageSingleAllocationLineItem({
      inventory,
      values,
      right,
      campaignId,
      currency
    })

    return [lineItem]
  }
}
